/* tslint:disable */
/* eslint-disable */
/**
 * smart-shop-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Point history response
 */
export interface PointResponseHistory {
    'id'?: number;
    'socialAccountId'?: number;
    'orderId'?: number;
    'paymentId'?: string;
    'pointType'?: PointResponseHistoryPointType;
    'pointAmount'?: number;
    'description'?: string;
    'creTm'?: string;
}

export const PointResponseHistoryPointType = {
    Earn: 'EARN',
    Use: 'USE',
    Restore: 'RESTORE',
    Review: 'REVIEW',
    Expire: 'EXPIRE',
    Admin: 'ADMIN',
} as const;

export type PointResponseHistoryPointType = typeof PointResponseHistoryPointType[keyof typeof PointResponseHistoryPointType];


